module.exports = __webpack_public_path__ + "static/img/cfo.6d3f4cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cfo/cfo.png
// module id = atDa
// module chunks = 34